export default "__VITE_ASSET__CoTxiHpq__"